import user from "./user";
import auth from "./auth";
import account from "./account";
export default {
  user,
  auth,
  account,
};
